// @ts-nocheck
/* Port of views/dashboard/module/UserEmailVerificationAclModal.js — byte-identical. */
import React, { useEffect, useState } from 'react';
import {
  EMAIL_VERIFICATION_ACL_OPTION,
  normalizeUsersEmailVerificationOptions,
} from '@/utilities/userEmailVerificationAcl';
import {
  AclSettingsModal,
  AclModalSection,
  AclModalOptionCheck,
  FaUser,
} from '@/features/acl-settings/aclSettingsUi';

const UserEmailVerificationAclModal = ({
  show,
  onHide,
  initialOptions,
  optionsConfigured = false,
  onSave,
  limitedByParent = false,
  canGrantEmailVerification = true,
}) => {
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    if (show) {
      const options = normalizeUsersEmailVerificationOptions(
        Array.isArray(initialOptions) ? initialOptions : [],
      );
      if (!optionsConfigured) {
        setEnabled(false);
      } else {
        setEnabled(options.includes(EMAIL_VERIFICATION_ACL_OPTION));
      }
    }
  }, [show, initialOptions, optionsConfigured, canGrantEmailVerification]);

  const handleReset = () => setEnabled(false);

  const handleSave = () => {
    if (!enabled) {
      onSave({ edit_options: [] });
    } else {
      onSave({ edit_options: [EMAIL_VERIFICATION_ACL_OPTION] });
    }
    onHide();
  };

  return (
    <AclSettingsModal
      show={show}
      onHide={onHide}
      title="Users — Email Verification Required"
      icon={FaUser}
      description="When enabled, this user must require OTP email verification when they create or edit users or agents, regardless of the new account's role or ACL."
      limitedByParent={limitedByParent}
      onSave={handleSave}
      onReset={handleReset}
      saveDisabled={!canGrantEmailVerification}
    >
      <AclModalSection
        icon={FaUser}
        title="Email Verification Required"
        subtitle="Users with this ACL must verify new user or agent emails via OTP when creating or editing accounts."
      >
        {!canGrantEmailVerification ? (
          <p className="acl-modal-empty">
            You do not have permission to grant email verification on Users.
          </p>
        ) : (
          <AclModalOptionCheck
            id="users-acl-email-verification"
            label="Email verification required"
            description="Require OTP when this user creates users or agents, or changes their email"
            checked={enabled}
            onChange={(e) => setEnabled(e.target.checked)}
          />
        )}
      </AclModalSection>
    </AclSettingsModal>
  );
};

export default UserEmailVerificationAclModal;
